import { render, staticRenderFns } from "./GenericContactType.vue?vue&type=template&id=449d0368"
import script from "./GenericContactType.vue?vue&type=script&lang=js"
export * from "./GenericContactType.vue?vue&type=script&lang=js"
import style0 from "./GenericContactType.vue?vue&type=style&index=0&id=449d0368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports